module.exports = {"361024100":"巴山镇","361024101":"相山镇","361024102":"航埠镇","361024103":"孙坊镇","361024104":"河上镇","361024105":"礼陂镇","361024106":"马鞍镇","361024200":"石庄乡","361024201":"六家桥乡","361024202":"白路乡","361024203":"三山乡","361024204":"白陂乡","361024205":"桃源乡","361024206":"许坊乡","361024207":"郭圩乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361024.json
// module id = 1231
// module chunks = 0